module.exports = __webpack_public_path__ + "static/media/mozza_bogo-dt-en.7c4e9406.jpg";